/**
 * Monospace / code font stack.
 * Matches the code font defined in GlobalStyles.tsx.
 * Import directly: `import { CODE_FONT_FAMILY } from '@stylesheets/font';`
 */
export const CODE_FONT_FAMILY =
  "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace";

/**
 * Sans font stack — single source of truth for the body/UI font.
 * Mirrored by the `body` rule in GlobalStyles.tsx; import this anywhere a
 * `font` shorthand needs an explicit family.
 */
export const SANS_FONT_FAMILY =
  "'Inter Variable', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', " +
  "'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', " +
  "'Helvetica Neue', sans-serif";

const font = {
  // Display
  displayLarge: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '57px',
    lineHeight: '64px',
    fontWeight: '600',
  },
  displayMedium: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '45px',
    lineHeight: '52px',
    fontWeight: '600',
  },
  displaySmall: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '36px',
    lineHeight: '44px',
    fontWeight: '600',
  },

  // Headline
  headlineLarge: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: '400',
  },
  headlineMedium: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: '400',
  },
  headlineSmall: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '400',
  },

  // Title
  titleLarge: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '22px',
    lineHeight: '28px',
    fontWeight: '600',
  },
  titleMedium: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontWeight: '600',
  },
  titleSmall: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    fontWeight: '600',
  },

  // Label
  labelLarge: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    fontWeight: '600',
  },
  labelMedium: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '26px',
    letterSpacing: '0.5px',
    fontWeight: '600',
  },
  labelSmall: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: '0.5px',
    fontWeight: '600',
  },

  // Body
  bodyLarge: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
  },
  bodyMedium: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '400',
  },
  bodySmall: {
    fontFamily: SANS_FONT_FAMILY,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '400',
  },
};

export default font;
